interface RuntimeConfig {
  sentry: {
    dsn: string | null
  }
}

function loadRuntimeConfig(): RuntimeConfig {
  try {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', 'assets/config.json', false)
    xhr.setRequestHeader('Accept', 'application/json')
    xhr.setRequestHeader('Cache-Control', 'no-cache')
    xhr.send(null)

    if (xhr.status === 200) {
      return JSON.parse(xhr.responseText)
    }
  } catch (error) {
    console.error('Failed to load runtime config:', error)
  }
  return { sentry: { dsn: null } }
}

export const runtimeConfig = loadRuntimeConfig()
